import { authConstants } from 'constants/actionTypes'
export const updateAccount = (payload) => ({
  type: authConstants.UPDATE_ACCOUNT,
  payload,
})

export const updateError = (payload) => ({
  type: authConstants.UPDATE_ERROR,
  payload,
})
export const updateToken = (payload) => ({
  type: authConstants.UPDATE_TOKEN,
  payload,
})
